import React from 'react';
import Text from 'design-system/Text';
import { countryCode } from '../../../constants';
const isGB = countryCode === 'GB';
export const trustStoryUserDeckViewItems = (isGBUser) => [
    {
        source: require('./img/trustStoryDeckViewAvatars/marcus.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @marcus{' '}
          </Text>
          <Text Text-14>just saved {isGBUser || isGB ? '£' : '$'}189</Text> per
          month by using Emma
        </Text>),
    },
    {
        source: require('./img/trustStoryDeckViewAvatars/george12.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @george12{' '}
          </Text>
          discovered he was{' '}
          <Text Text-14>
            overpaying {isGBUser || isGB ? '£' : '$'}200 a year
          </Text>{' '}
          on insurance!
        </Text>),
    },
    isGB && {
        firstName: 'Noah',
        lastName: 'Davies',
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @noahdavies{' '}
          </Text>
          <Text Text-14>
            earned {isGBUser || isGB ? '£' : '$'}98.50 in interest
          </Text>{' '}
          in Emma
        </Text>),
    },
    isGB && {
        source: require('./img/trustStoryDeckViewAvatars/monica.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @monica{' '}
          </Text>
          has <Text Text-14>started investing</Text> in Emma
        </Text>),
    },
    {
        source: require('./img/trustStoryDeckViewAvatars/ank88.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @ank88{' '}
          </Text>
          <Text Text-14>has {isGBUser || isGB ? '£' : '$'}250</Text> left from
          her groceries and shopping budgets!
        </Text>),
    },
    isGB && {
        source: require('./img/trustStoryDeckViewAvatars/chance.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @chance{' '}
          </Text>
          <Text Text-14>has boosted his credit history</Text> with Emma
        </Text>),
    },
    {
        firstName: 'Grace',
        lastName: 'Joshi',
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @grace10{' '}
          </Text>
          used Emma to track her spending and{' '}
          <Text Text-14>cut costs on Eating out</Text>
        </Text>),
    },
    isGB && {
        source: require('./img/trustStoryDeckViewAvatars/brd.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @brd{' '}
          </Text>
          <Text Text-14>has saved {isGBUser || isGB ? '£' : '$'}20</Text> per
          month by switching energy via Emma
        </Text>),
    },
    isGB && {
        source: require('./img/trustStoryDeckViewAvatars/mmMia.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @mm_mia{' '}
          </Text>
          <Text Text-14>has boosted her credit score</Text> by paying bills on
          time with Emma
        </Text>),
    },
    {
        source: require('./img/trustStoryDeckViewAvatars/sophie.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @sophie{' '}
          </Text>
          <Text Text-14>has {isGBUser || isGB ? '£' : '$'}300</Text> left from
          her monthly budget thanks to smart tracking!
        </Text>),
    },
    {
        firstName: 'Chris',
        lastName: 'Pratt',
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @cp_310{' '}
          </Text>
          <Text Text-14>found 2 Netflix subscriptions</Text> using Emma
        </Text>),
    },
    {
        source: require('./img/trustStoryDeckViewAvatars/ellaBrown.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @ellabrown{' '}
          </Text>
          <Text Text-14>earned {isGBUser || isGB ? '£' : '$'}23.50</Text> in
          cashback rewards
        </Text>),
    },
    {
        firstName: 'Ava',
        lastName: 'Wilson',
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @avawilson{' '}
          </Text>
          has<Text Text-14> reached her emergency fund goal </Text>3 months
          ahead of schedule
        </Text>),
    },
    {
        source: require('./img/trustStoryDeckViewAvatars/kianna.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @kianna{' '}
          </Text>
          <Text Text-14>has created a holiday </Text>spending group in Emma
        </Text>),
    },
    {
        source: require('./img/trustStoryDeckViewAvatars/xx888.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @xx888
          </Text>
          <Text Text-14> found 3 forgotten subscriptions </Text>using Emma
        </Text>),
    },
    isGB && {
        firstName: 'Isla',
        lastName: 'Taylor',
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @islataylor{' '}
          </Text>
          <Text Text-14>has saved {isGBUser || isGB ? '£' : '$'}15</Text> per
          month by switching to a cheaper broadband deal via Emma
        </Text>),
    },
    {
        source: require('./img/trustStoryDeckViewAvatars/oliverSmith.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @oliversmith{' '}
          </Text>
          <Text Text-14>has saved {isGBUser || isGB ? '£' : '$'}120</Text> per
          month by canceling unused subscriptions
        </Text>),
    },
    {
        source: require('./img/trustStoryDeckViewAvatars/jack.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @20jack{' '}
          </Text>
          <Text Text-14>created a holiday savings group</Text> to plan his dream
          trip
        </Text>),
    },
    {
        source: require('./img/trustStoryDeckViewAvatars/marcus.png'),
        info: (<Text TextThin-14>
          <Text TextThin-14 Secondary>
            @marcus{' '}
          </Text>
          <Text Text-14>just saved {isGBUser || isGB ? '£' : '$'}189</Text> per
          month by using Emma
        </Text>),
    },
].filter((story) => !!story);
